import {
  params,
  string as stringType,
  shape as shapeType,
  number as numberType,
  bool as boolType
} from '@thd-nucleus/data-sources';

export const dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    installServices: shapeType({
      scheduleAMeasure: boolType()
    }),
    info: shapeType({
      classNumber: stringType()
    }),
    pricing: params({ storeId: stringType() }).shape({
      alternate: shapeType({
        unit: {
          caseUnitOfMeasure: stringType(),
          unitsOriginalPrice: numberType({ float: true }),
          unitsPerCase: numberType({ float: true }),
          value: numberType({ float: true }),
        },
      }),
    }),
  })
};